import React, { useEffect, useRef } from 'react'
import { VideoEl } from './elements'
import LessonStore from '../../stores/LessonStore'
import { withRouter } from 'react-router-dom'

const Video = ({ history, nextVideo, course }) => {
  const {
    data: { otp, playbackInfo, type },
    saveResumeVideioLink,
    config,
  } = LessonStore.useContainer()
  const container = useRef(null)
  const pathName = history.location.pathname
  useEffect(() => {
    if (!container.current) {
      return
    }
    const video = new window.VdoPlayer({
      otp: otp,
      playbackInfo: playbackInfo,
      theme: '9ae8bbe8dd964ddc9bdb932cca1cb59a',
      container: container.current,
    })
    if (config) {
      saveResumeVideioLink(pathName, config, { ...course, type: 'recorded' })
    }
    const videoEndListener = () => history.push(nextVideo)
    const videoEndEvent = video.addEventListener('ended', videoEndListener)

    return () => videoEndEvent()
  }, [otp, playbackInfo, history, nextVideo])

  return type === 'ASSIGNMENT' ? null : (
    <VideoEl>
      {otp && playbackInfo ? (
        <div
          onContextMenu={(e) => e.preventDefault()}
          ref={container}
          className='videoContent'
        />
      ) : (
        <p className='notFound'>Video Not Found!</p>
      )}
    </VideoEl>
  )
}

export default withRouter(Video)
